


















import { Component, Watch, Vue, Prop, Inject } from 'vue-property-decorator'

@Component
export default class InputPassword extends Vue {
  password: string = null
  showPassword: boolean = false

  @Prop({ type: String, default: null }) label: string
  @Prop({ type: Boolean, default: false }) minLength: boolean
  @Prop({ type: String, default: 'field' }) name: string
  @Prop({ type: String, default: null }) type: string
  @Prop( [String, Array] ) message: [string, []]

  @Inject('$validator') $validator

  emitPassword() {
    this.$emit('input', this.password)
  }
}
